//React
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Form } from 'react-bootstrap';
//API
import { HospitalApi, TemplateApi, WoundApi } from '../../apis/index';
//Material-UI
import Grid from '@material-ui/core/Grid';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

//Components
import MyLoading from '../../components/Loading.js';
import BasicModal, { ModalComponent } from '../../components/Modal.js';
import countryCodeName from '../../components/countryCode.js';
import { set } from 'lodash';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(17px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#3F598C',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
    transform: 'translateY(5%)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const CustomFormControl = styled(Form.Control)`
  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

const HospitalSave = (props) => {
  const [hospital, setHospital] = useState({});
  const [emblem, setEmblem] = useState({});
  const [woundType, setWoundType] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const settings = {
    togglenYn: false,
    hiddenYn: false,
    autoIssued: true,
    aiDrawYn: true,
    disableYn: false,
    woundName: null,
    kitMetaId: null,
    woundListId: null,
  };

  const [modalStatus, setModalStatus] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalStatus2, setModalStatus2] = useState(false);
  const [CheckmodalContent, setCheckmodalContent] = useState('');
  const [checkModlaValue, setCheckModalValue] = useState();
  const [emailCheck, setEmailCheck] = useState(0);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getWoundTypeList();
    getTemplateList();
  }, []);

  const getWoundTypeList = async () => {
    try {
      const woundRes = await WoundApi.getWoundList();
      const wound = woundRes.data.map((woundList) => ({
        woundListId: woundList.id,
        woundName: woundList.woundName,
      }));

      const result = wound.map((item) => ({
        [item.woundListId]: { ...settings, ...item },
      }));

      setWoundType(result);
    } catch (error) {
      console.error('Failed to fetch Wound data:', error);
    }
  };

  const getTemplateList = async () => {
    try {
      const templateRes = await TemplateApi.getTemplate();
      setTemplateList(templateRes.data);
    } catch (error) {
      console.error('Failed to fetch Template data:', error);
    }
  };

  const templateName = useMemo(() => {
    return templateList.map((template) => ({
      label: template.templateName,
      id: template.id,
    }));
  }, [templateList]);

  const handleChangeHospital = (e) => {
    setHospital({
      ...hospital,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeCountryCode = (e, value) => {
    if (value) {
      setHospital({
        ...hospital,
        countryCode: value.label,
      });
    } else {
      setHospital({
        ...hospital,
        countryCode: '',
      });
    }
  };

  useEffect(() => {
    if (hospital.countryCode === 'USA') {
      setHospital((prevHospital) => ({
        ...prevHospital,
        productName: 'APLICOR 3D',
      }));
    } else if (hospital.countryCode) {
      setHospital((prevHospital) => ({
        ...prevHospital,
        productName: 'Dr. INVIVO',
      }));
    } else {
      setHospital((prevHospital) => ({
        ...prevHospital,
        productName: '',
      }));
    }
  }, [hospital.countryCode]);

  const handleChangeWound = (e) => {
    const [woundListId, key] = e.target.name.split(',');
    setWoundType((prevWoundType) => {
      const newWoundType = [...prevWoundType];
      const index = newWoundType.findIndex((obj) =>
        obj.hasOwnProperty(woundListId),
      );
      if (index !== -1) {
        newWoundType[index] = {
          ...newWoundType[index],
          [woundListId]: {
            ...newWoundType[index][woundListId],
            [key]: e.target.checked,
          },
        };
      }
      return newWoundType;
    });
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return regex.test(email);
  };

  const handleChangeEmail = (e) => {
    if (!validateEmail(e.target.value)) {
      setEmailStyle1({ border: '1px solid red' });
      setEmailCheck(1);
    } else {
      setEmailCheck(2);
      setEmailStyle1({ border: '1px solid #3F598C' });
    }
    if (e.target.value.length === 0) {
      setEmailCheck(0);
    }
    setHospital({
      ...hospital,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeTemplate = (woundType) => (e, value) => {
    const [woundListId, key] = woundType.split(',');
    setWoundType((prevWoundType) => {
      const newWoundType = [...prevWoundType];
      const index = newWoundType.findIndex((obj) =>
        obj.hasOwnProperty(woundListId),
      );
      if (index !== -1) {
        newWoundType[index] = {
          ...newWoundType[index],
          [woundListId]: {
            ...newWoundType[index][woundListId],
            [key]: value ? value.id : null,
          },
        };
      }
      return newWoundType;
    });
  };

  const submitHospital = async (e) => {
    e.preventDefault();
    setLoading(true);

    // FormData 초기화 및 필수 항목 확인
    const formData = new FormData();
    if (!hospital.hospitalName) {
      showModalWithContent('Please set Hospital Name.');
      handleModalOpen();
      setLoading(false);
      return;
    }

    // 이메일 관련 검증 및 모달 처리
    if (!hospital.email || !hospital.email.trim()) {
      showModalWithContent('병원 이메일 주소를 입력하지 않았습니다.');
      handleModalOpen();
      setLoading(false);
      return;
    } else if (!validateEmail(hospital.email)) {
      showModalWithContent('Please enter a valid email address.');
      handleModalOpen();
      setLoading(false);
      return;
    }
    if (hospital.email && !validateEmail(hospital.email)) {
      showModalWithContent('Please enter a valid email address.');
      handleModalOpen();
      setLoading(false);
      return;
    }
    if (!hospital.countryCode) {
      showModalWithContent('Please select a country code.');
      handleModalOpen();
      setLoading(false);
      return;
    }

    // FormData에 병원 정보 추가
    formData.append('hospitalName', hospital.hospitalName);
    if (hospital.email) {
      formData.append('email', hospital.email);
    }
    if (hospital.location) {
      formData.append('location', hospital.location);
    }
    formData.append('countryCode', hospital.countryCode);
    formData.append('emblem', emblem);
    formData.append('productName', hospital.productName);

    // woundType 필터링 및 검증
    const woundData = woundType.filter(
      (wt) => wt[Object.keys(wt)[0]].togglenYn,
    );

    if (woundData.length === 0) {
      showModalWithContent('wound를 최소 하나 이상 선택해주세요.');
      handleModalOpen();
      setLoading(false);
      return;
    }

    let flag = true;
    // woundData를 FormData에 추가
    woundData.forEach((wd, i) => {
      const key = Object.keys(wd)[0];

      if (!wd[key].kitMetaId) {
        showModalWithContent('설정된 Template이 없습니다.');
        handleModalOpen();
        setLoading(false);
        flag = false;
        return;
      }

      formData.append(`woundFlagRegisterList[${i}].aiDrawYn`, wd[key].aiDrawYn);
      formData.append(
        `woundFlagRegisterList[${i}].autoIssued`,
        wd[key].autoIssued,
      );
      formData.append(
        `woundFlagRegisterList[${i}].disableYn`,
        wd[key].disableYn,
      );
      formData.append(`woundFlagRegisterList[${i}].hiddenYn`, wd[key].hiddenYn);
      formData.append(
        `woundFlagRegisterList[${i}].kitMetaId`,
        wd[key].kitMetaId,
      );
      formData.append(
        `woundFlagRegisterList[${i}].woundListId`,
        wd[key].woundListId,
      );
    });

    if (flag) {
      // 병원 정보 저장 API 호출
      try {
        const res = await HospitalApi.saveHospital(formData);
        if (res.statusCode === 200) {
          props.history.push('/hospitalAdminList');
        } else {
          setLoading(false);
          showModalWithContent(res.statusCode + '\n' + res.message);
          handleModalOpen();
          return;
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }
  };

  const templateLink = (data) => {
    const objectKey = woundType.find((obj) => obj.hasOwnProperty(data));
    const valueOfkitMetaId = objectKey ? objectKey[data].kitMetaId : null;

    if (valueOfkitMetaId) {
      window.open('/updateTemplate/' + valueOfkitMetaId);
    }
  };

  const [uploadImgUrl, setUploadImgUrl] = useState('');
  const fileInputRef = useRef(null);

  const onchangeImageUpload = (e) => {
    const { files } = e.target;
    const uploadFile = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(uploadFile);
    reader.onloadend = () => {
      setUploadImgUrl(reader.result);
    };
    setEmblem(uploadFile);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const deleteImga = () => {
    setUploadImgUrl(null);
    setEmblem(null);
  };

  const handleModalOpen = () => {
    setModalStatus(true);
  };

  const handleModalClose = () => {
    setModalStatus(false);
  };

  const showModalWithContent = (content) => {
    setModalContent(content);
  };

  useEffect(() => {
    if (modalContent) {
      setModalStatus(true);
    }
  }, [modalContent]);

  const [handleClose, setHandleClose] = useState(() => () => {});

  const showModal = () => {
    return new Promise((resolve, reject) => {
      setModalStatus2(true);
      setHandleClose(() => (userChoice) => {
        if (userChoice) {
          resolve('User agreed.');
        } else {
          reject('User disagreed.');
        }
        setModalStatus2(false);
      });
    });
  };

  useEffect(() => {
    if (CheckmodalContent) {
      setModalStatus2(true);
    }
  }, [CheckmodalContent]);

  const emailStyle = {
    border: '1px solid #D9D9D9',
  };

  const [emailStyle1, setEmailStyle1] = useState(emailStyle);

  return (
    <div>
      <style>
        {`
        .form-control::placeholder {
          color: #B6BCC5;
        }
        `}
      </style>
      <h1>ADD HOSPITAL & SEND INVITATION</h1>
      <Form
        onSubmit={submitHospital}
        onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      >
        <Form.Group>
          <span>Email</span>
          <span style={{ color: 'red' }}> *</span>
          <div style={{ display: 'flex', position: 'relative' }}>
            <CustomFormControl
              style={{
                ...(hospital.email ? emailStyle1 : emailStyle),
                margin: '0px',
              }}
              type="text"
              placeholder="Enter email address..."
              name="email"
              autoComplete="off"
              onChange={handleChangeEmail}
              maxLength={100}
            />
            <div
              style={{
                display: emailCheck === 1 ? 'block' : 'none',
                position: 'absolute',
                right: '10px',
                top: '50%',
                color: 'red',
                transform: 'translateY(-50%) rotate(180deg)',
              }}
            >
              <InfoOutlinedIcon color="red" />
            </div>
            <div
              style={{
                display: emailCheck === 2 ? 'block' : 'none',
                position: 'absolute',
                right: '10px',
                top: '7px',
                color: '#3F598C',
              }}
            >
              <CheckCircleOutlinedIcon />
            </div>
          </div>
          {emailCheck === 1 ? (
            <div style={{ color: 'red', fontSize: '12px' }}>Invalid email</div>
          ) : (
            <div style={{ paddingBottom: '17px' }}></div>
          )}
        </Form.Group>
        <Form.Group>
          <span>Hospital Name</span>
          <span style={{ color: 'red' }}> *</span>
          <Form.Control
            style={{ margin: '0px' }}
            type="text"
            placeholder="Enter hospital name..."
            name="hospitalName"
            autoComplete="off"
            onChange={handleChangeHospital}
            maxLength={30}
            value={hospital.hospitalName || ''}
          />
        </Form.Group>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Form.Group>
            <div style={{ width: '224px', marginRight: '15px' }}>
              <span>Hospital Country Code</span>
              <span style={{ color: 'red' }}> *</span>
              <AutoComplete
                size="small"
                disablePortal
                options={countryCodeName}
                name="countryCode"
                onChange={handleChangeCountryCode}
                value={hospital.countryCode || ''}
                sx={{ width: '100%' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Enter country code..."
                    sx={{
                      '& legend': { display: 'none' },
                      '& fieldset': { top: 0 },
                    }}
                  />
                )}
              />
            </div>
          </Form.Group>
          <Form.Group style={{ width: '100%' }}>
            <span>Hospital Location</span>
            <Form.Control
              style={{ margin: '0px' }}
              type="text"
              placeholder="Hospital Location"
              name="location"
              autoComplete="off"
              onChange={handleChangeHospital}
              maxLength={30}
              value={hospital.location || ''}
            />
          </Form.Group>
        </div>
        <Form.Group>
          <span>Product Name</span>
          <Form.Control
            type="text"
            placeholder="Product Name"
            name="productName"
            autoComplete="off"
            required
            value={hospital.productName || ''}
            disabled
          />
        </Form.Group>
        <Form.Group controlId="formBasicPassword">
          <span>Emblem Image</span>
          <div
            style={{
              width: '250px',
              height: '250px',
              border: '1px solid #B6BCC5',
              borderRadius: '4px',
              backgroundColor: '#FFF',
              boxSizing: 'border-box',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {uploadImgUrl ? (
              <div
                style={{
                  position: 'relative',
                  width: '240px',
                  height: '240px',
                }}
              >
                <img
                  src={uploadImgUrl}
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
                <button
                  type="button"
                  style={{ position: 'absolute', top: '10px', right: '10px' }}
                  onClick={deleteImga}
                >
                  <CancelRoundedIcon
                    sx={{
                      fontSize: {
                        xs: '25px',
                      },
                      color: 'red',
                    }}
                  />
                </button>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <CloudUploadIcon
                  sx={{
                    fontSize: {
                      xs: '50px',
                    },
                  }}
                />
                <div>Upload File</div>
                <div style={{ paddingTop: '10px', fontSize: '12px' }}>
                  *Max file size: 5MB
                </div>
                <div style={{ fontSize: '12px' }}>*JPG, GIF, PNG</div>
              </div>
            )}
          </div>
          <input
            style={{ display: 'none' }}
            type="file"
            accept="image/*"
            onChange={onchangeImageUpload}
            placeholder="CHOOSE IMAGES"
            ref={fileInputRef}
          />
          <button
            type="button"
            onClick={handleButtonClick}
            style={{
              marginLeft: '35px',
              marginTop: '10px',
              outline: 'none',
              width: '170px',
              height: '38px',
              background: '#fff',
              color: '#3f598c',
              fontSize: '15px',
              fontWeight: '500',
              borderRadius: '5px',
              border: '2px solid #3f598c',
              cursor: 'pointer',
            }}
          >
            CHOOSE IMAGES
          </button>
        </Form.Group>

        <div>What's Template</div>
        <div style={{ display: 'flex', paddingTop: '10px' }}>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057',
              }}
            >
              <div>ST-160-160</div>
              <div style={{ marginTop: '-15px' }}>___________</div>
              <div style={{ marginTop: '-5px' }}>①</div>
            </div>
          </div>
          <div style={{ marginTop: '5px' }}> - </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057',
              }}
            >
              <div>KIT-02</div>
              <div style={{ marginTop: '-15px' }}>______</div>
              <div style={{ marginTop: '-5px' }}>②</div>
            </div>
          </div>
          <div style={{ marginTop: '5px' }}> - </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057',
              }}
            >
              <div>EV</div>
              <div style={{ marginTop: '-15px' }}>__</div>
              <div style={{ marginTop: '-5px' }}>③</div>
            </div>
          </div>
          <div style={{ marginTop: '5px' }}> - </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057',
              }}
            >
              <div>D1-01</div>
              <div style={{ marginTop: '-15px' }}>_____</div>
              <div style={{ marginTop: '-5px' }}>④</div>
            </div>
          </div>
          <div style={{ paddingLeft: '30px', color: '#495057' }}>
            <div>
              ① 압출량(ST): 강도 조절 미 버전=160-160, 강도 조절 버전=110-110
            </div>
            <div>② KIT 종류(KIT): AI Regen KIT=01, 분리형 키트=02</div>
            <div>③ 필라멘트 종류: Evonic(EV), Glueone(GL)</div>
            <div>④ Dispenser1(D1) 종류: 구형=01, 신형=02</div>
          </div>
        </div>

        <span>Wound Type</span>
        <span style={{ color: 'red' }}> *</span>
        {woundType.map((woundList, index) => {
          const woundData = woundList[Object.keys(woundList)];
          return (
            <div key={index}>
              <div
                style={{
                  transition: 'all 0.5s',
                  background: '#fff',
                  width: '100%',
                  padding: '20px 20px 10px 20px',
                  marginBottom: 30,
                  alignItems: 'center',
                  borderRadius: '10px',
                  flexDirection: 'row',
                  border: woundData.togglenYn
                    ? '1px solid #3F598C'
                    : '1px solid #D9D9D9',
                }}
              >
                <FormControlLabel
                  style={{ userSelect: 'none' }}
                  control={<IOSSwitch sx={{ m: 1 }} />}
                  label={
                    <div sx={{ fontSize: '24px', fontWeight: '500' }}>
                      {woundData.woundName}
                    </div>
                  }
                  labelPlacement="start"
                  name={`${woundData.woundListId},togglenYn`}
                  checked={woundData.togglenYn}
                  onChange={handleChangeWound}
                />
                <div
                  style={{
                    transition: 'all 0.5s',
                    boxSizing: 'border-box',
                    height: woundData.togglenYn ? '150px' : '0',
                    opacity: woundData.togglenYn ? '1' : '0',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                    }}
                  >
                    <FormControlLabel
                      style={{ userSelect: 'none' }}
                      control={
                        <Checkbox
                          sx={{
                            color: '#3F598C',
                            '&.Mui-checked': { color: '#3F598C' },
                          }}
                          checked={woundData.autoIssued}
                          onChange={handleChangeWound}
                          name={`${woundData.woundListId},autoIssued`}
                        />
                      }
                      label="Auto Issue"
                    />
                    <FormControlLabel
                      style={{ userSelect: 'none' }}
                      control={
                        <Checkbox
                          sx={{
                            color: '#3F598C',
                            '&.Mui-checked': { color: '#3F598C' },
                          }}
                          checked={woundData.aiDrawYn}
                          onChange={handleChangeWound}
                          name={`${woundData.woundListId},aiDrawYn`}
                        />
                      }
                      label="Auto Draw"
                    />
                    <FormControlLabel
                      style={{ userSelect: 'none' }}
                      control={
                        <Checkbox
                          sx={{
                            color: '#3F598C',
                            '&.Mui-checked': { color: '#3F598C' },
                          }}
                          checked={woundData.hiddenYn}
                          onChange={handleChangeWound}
                          name={`${woundData.woundListId},hiddenYn`}
                        />
                      }
                      label="Hidden"
                    />
                    <FormControlLabel
                      style={{ userSelect: 'none' }}
                      control={
                        <Checkbox
                          sx={{
                            color: '#3F598C',
                            '&.Mui-checked': { color: '#3F598C' },
                          }}
                          checked={woundData.disableYn}
                          onChange={handleChangeWound}
                          name={`${woundData.woundListId},disableYn`}
                        />
                      }
                      label="Disable"
                    />
                  </div>
                  <Form.Group>
                    <AutoComplete
                      disablePortal
                      options={templateName}
                      onChange={handleChangeTemplate(
                        `${woundData.woundListId},kitMetaId`,
                      )}
                      sx={{ width: '100%' }}
                      renderInput={(params) => (
                        <TextField {...params} label="Set Template" />
                      )}
                    />
                  </Form.Group>
                  <button
                    type="button"
                    style={{ marginTop: '-10px' }}
                    onClick={() => templateLink(woundData.woundListId)}
                  >
                    Template 이동
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <button
            className="red"
            onClick={() => props.history.goBack()}
            style={{ marginRight: '25px' }}
          >
            Back
          </button>
          <button className="blue" type="submit" style={{ maringLeft: '25px' }}>
            Save
          </button>
        </Grid>
      </Form>
      <div style={{ display: 'none' }}>
        <BasicModal
          open={modalStatus}
          handleModalClose={handleModalClose}
          content={modalContent}
        />
        <ModalComponent
          open={modalStatus2}
          handleModalClose={(userChoice) => handleClose(userChoice)}
          content={CheckmodalContent}
        />
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </div>
  );
};

export default HospitalSave;
